module.exports = __webpack_public_path__ + "static/img/CgoRC2REgzeAflM8AAWg1hvtsF0410.82ab060.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2REgzeAflM8AAWg1hvtsF0410.jpg
// module id = HQBy
// module chunks = 73